import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { NOTES_TEMPLATE_CONTROLLER_ID_REMOVE } from "api/Service";

export const useDeleteNoteTemplate = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (id) => {
      const axiosInstance = createAxiosInstance();
      await axiosInstance.delete(
        `${tenantVal}${NOTES_TEMPLATE_CONTROLLER_ID_REMOVE}`,
        { data: { id, tenant: tenantVal } }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["noteTemplatesAll"] });
    },
  });
};
